import Resource from '@/plugins/sdk/Resource'
import { UUID, DATETIME, ITEM } from '@/plugins/sdk/fields'
import Lead from '@/plugins/sdk/resources/Account/Lead'
import ItemType from '@/plugins/sdk/resources/Dictionary/ItemType'

export default class extends Resource {
  static name = 'account_lead_freight'

  static get fields () {
    return {
      id: new UUID(),
      created_at: new DATETIME(),
      updated_at: new DATETIME(),
      deleted_at: new DATETIME(),
      type: new ITEM(ItemType),
      lead: new ITEM(Lead)
    }
  }
}
